export default __webpack_public_path__ + "static/logo-2cbf8a93d695d37b49bf68a9ab34c27d.png";